/* ============================================================
   MATCH & MEASURE - one unified tool.
   Customer adds each plant WITH its pot size. The tool:
   1) converts every pot to litres -> bags (frustum volume, root-ball x0.85)
   2) recommends the SMALLEST set of mixes for the whole collection
      (capped tier system + compatibility scoring)
   3) totals the bags per recommended mix and adds them to cart as ONE
      bundle at the live tier price.
   Self-contained feature: all files listed in MATCH-AND-MEASURE-FILES.md.
   Config comes from window.terreneMM (set by the section): live bundle
   tier prices from the Build Your Bundle variants. No hardcoded prices.
============================================================ */
(function () {
  'use strict';

  var CFG = window.terreneMM || {};
  var TIERS = (CFG.tiers || []).filter(function (t) { return t.u > 0 && t.id; });
  var MIXES = CFG.mixes || {};
  var CAP = CFG.capBags || 10;
  /* A bag nominally fills 4.5 L but stretches to BAGMAX (default 5 L). Bag
     counts divide by BAGMAX so a 4.7 L pot is still ONE bag — a new bag is
     only added once the pooled litres exceed the stretch limit. */
  var BAGMAX = CFG.bagMax || 5;
  var BAGVOL = CFG.bagVolText || '4.5 - 5 litres';
  var MAIL = CFG.contactEmail || 'support@terrenehouse.com';

  /* ---- The 8 mix habitat profiles (0-10 per dimension) ---- */
  var mixProfiles = {
    'aroid-alchemist': { name: 'Aroid Alchemist', drainage: 7,  moisture: 6, aeration: 8,  nutrient: 6 },
    'desert-jewel':    { name: 'Desert Jewel',    drainage: 10, moisture: 2, aeration: 6,  nutrient: 3 },
    'immortal-duo':    { name: 'Immortal Duo',    drainage: 8,  moisture: 5, aeration: 7,  nutrient: 6 },
    'humid-haven':     { name: 'Humid Haven',     drainage: 4,  moisture: 9, aeration: 4,  nutrient: 6 },
    'sky-dwellers':    { name: 'Sky Dwellers',    drainage: 9,  moisture: 3, aeration: 10, nutrient: 4 },
    'bloom-booster':   { name: 'Bloom Booster',   drainage: 6,  moisture: 7, aeration: 5,  nutrient: 9 },
    'frond-sovereign': { name: 'Frond Sovereign', drainage: 7,  moisture: 6, aeration: 5,  nutrient: 7 },
    'iron-roots':      { name: 'Iron Roots',      drainage: 9,  moisture: 2, aeration: 4,  nutrient: 3 }
  };

  /* ---- Core matching math ---- */
  function calculateCompatibility(plant, candidate) {
    if (plant.mix === candidate) return plant.compatibility;
    var a = mixProfiles[plant.mix], b = mixProfiles[candidate];
    if (!a || !b) return 30;
    var diff = Math.abs(a.drainage - b.drainage) + Math.abs(a.moisture - b.moisture) +
               Math.abs(a.aeration - b.aeration) + Math.abs(a.nutrient - b.nutrient);
    var score = plant.compatibility - diff * 2.5;
    return Math.max(30, Math.min(plant.compatibility, Math.round(score)));
  }

  function getMaxRecommendedMixes(n) {
    if (n >= 15) return 8;
    if (n >= 12) return 6;
    if (n >= 10) return 5;
    if (n >= 8)  return 4;
    if (n >= 6)  return 3;
    return 2;
  }

  function getCombinations(arr, n) {
    if (n === 1) return arr.map(function (x) { return [x]; });
    var out = [];
    arr.forEach(function (item, i) {
      getCombinations(arr.slice(i + 1), n - 1).forEach(function (c) {
        out.push([item].concat(c));
      });
    });
    return out;
  }

  function findBestMixSet(plants) {
    var all = Object.keys(mixProfiles);
    var n = getMaxRecommendedMixes(plants.length);

    if (n >= all.length) {
      var assigns = plants.map(function (p) {
        return { plant: p, assignedMix: p.mix, compatibility: p.compatibility };
      });
      var avg = assigns.reduce(function (s, a) { return s + a.compatibility; }, 0) / assigns.length;
      return { mixSet: all, assignments: assigns, avgScore: avg };
    }

    var best = null, bestScore = -1, bestAssigns = null;
    getCombinations(all, n).forEach(function (combo) {
      var total = 0, assigns = [];
      plants.forEach(function (p) {
        var bm = combo[0], bc = calculateCompatibility(p, combo[0]);
        combo.forEach(function (h) {
          var c = calculateCompatibility(p, h);
          if (c > bc) { bc = c; bm = h; }
        });
        total += bc;
        assigns.push({ plant: p, assignedMix: bm, compatibility: bc });
      });
      var avg = total / plants.length;
      if (avg > bestScore) { bestScore = avg; best = combo; bestAssigns = assigns; }
    });
    return { mixSet: best, assignments: bestAssigns, avgScore: bestScore };
  }

  /* ---- Pot volume (conical frustum) ---- */
  function potVolumeLiters(h, top, bottom) {
    var R = top / 2, r = bottom / 2;
    return (Math.PI * h / 3) * (R * R + R * r + r * r) / 1000;
  }
  function bagsNeeded(liters) {
    var trueNeed = Math.max(1, Math.ceil(liters / BAGMAX - 0.000001));
    return {
      bagsTrueNeed: trueNeed,
      bagsToBuy: Math.min(trueNeed, CAP),
      exceedsCap: trueNeed > CAP
    };
  }

  /* ---- Pricing (live tiers embedded by Liquid; paise) ---- */
  function tierFor(units) {
    for (var i = 0; i < TIERS.length; i++) if (TIERS[i].u === units) return TIERS[i];
    return null;
  }
  function singleBagPaise() { var t = tierFor(1); return t ? t.p : 0; }
  function rs(paise) { return 'Rs.' + Math.round(paise / 100).toLocaleString('en-IN'); }

  /* ---- Helpers ---- */
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function el(id) { return document.getElementById(id); }
  function debounce(fn, ms) {
    var t; return function () { var a = arguments, c = this;
      clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); };
  }
  function searchPlants(q, database) {
    q = q.toLowerCase().trim();
    if (q.length < 2) return [];
    return database.filter(function (p) {
      if (p.commonName.toLowerCase().indexOf(q) !== -1) return true;
      return p.aliases.some(function (a) { return a.toLowerCase().indexOf(q) !== -1; });
    }).slice(0, 8);
  }
  function mixTitle(handle) { return (MIXES[handle] && MIXES[handle].title) || (mixProfiles[handle] ? mixProfiles[handle].name : handle); }
  function shortMix(handle) { return mixProfiles[handle] ? mixProfiles[handle].name : mixTitle(handle); }

  /* ---- Add to cart via the store's BUNDLE mechanism (merges with any
     bundle already in the cart; one tier variant + mixes as properties) ---- */
  function addBundle(mixCounts, btn) {
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding...';
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var existing = null;
      (cart.items || []).forEach(function (it) { if (it.handle === 'build-your-bundle') existing = it; });
      var props = {}, total = 0;
      if (existing && existing.properties) {
        Object.keys(existing.properties).forEach(function (k) {
          props[k] = existing.properties[k];
          if (k.charAt(0) !== '_') total += parseInt(existing.properties[k], 10) || 0;
        });
      }
      Object.keys(mixCounts).forEach(function (title) {
        var q = mixCounts[title];
        if (q > 0) { props[title] = String((parseInt(props[title], 10) || 0) + q); total += q; }
      });
      if (total > CAP) {
        btn.disabled = false; btn.textContent = label;
        alert('Orders are capped at ' + CAP + ' bags per order' +
              (existing ? ' (your cart already has some bags)' : '') +
              '. Contact us at ' + MAIL + ' for larger requirements.');
        return;
      }
      var tier = tierFor(total);
      if (!tier) {
        btn.disabled = false; btn.textContent = label;
        alert('No price tier found for ' + total + ' bags. Please contact ' + MAIL + '.');
        return;
      }
      var next = existing
        ? fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: existing.key, quantity: 0 }) })
        : Promise.resolve();
      next.then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: tier.id, quantity: 1, properties: props }) });
      }).then(function (r) {
        if (!r.ok) throw 0;
        clearState();   /* order built — a fresh visit starts clean */
        window.location.href = '/cart';
      }).catch(function () {
        btn.disabled = false; btn.textContent = label;
        alert('Could not add to cart. Please try again.');
      });
    }).catch(function () {
      btn.disabled = false; btn.textContent = label;
      alert('Could not read your cart. Please try again.');
    });
  }

  /* ============================================================
     UNIFIED TOOL
  ============================================================ */
  var db = [];
  var picked = null;      /* plant currently being added */
  var entries = [];       /* {plant, h, top, bottom, liters, bags, measured} */
  var showAllRows = false;
  var volOnly = false;    /* "forget the plant & mix" mode: litres only */

  /* ---- Session persistence: reading a mix page mid-flow must not erase
     progress. State lives in sessionStorage (same tab), restored on load,
     cleared after a successful add-to-cart or when the tab closes. ---- */
  var STORE_KEY = 'th_mm_state';
  function saveState() {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({
        e: entries.map(function (en) {
          return { n: en.plant.commonName, h: en.h, top: en.top, bottom: en.bottom, l: en.liters, b: en.bags };
        }),
        p: picked ? picked.commonName : null,
        v: volOnly,
        s: {
          h: (el('mm-h') || {}).value,
          t: (el('mm-top') || {}).value,
          b: (el('mm-bottom') || {}).value
        }
      }));
    } catch (err) {}
  }
  function clearState() {
    try { sessionStorage.removeItem(STORE_KEY); } catch (err) {}
  }
  function restoreState() {
    var raw = null;
    try { raw = sessionStorage.getItem(STORE_KEY); } catch (err) {}
    if (!raw) return;
    var st = null;
    try { st = JSON.parse(raw); } catch (err) { return; }
    if (!st) return;
    var byName = {};
    db.forEach(function (p) { byName[p.commonName] = p; });
    (st.e || []).forEach(function (en) {
      var p = byName[en.n];
      if (p) entries.push({ plant: p, h: en.h, top: en.top, bottom: en.bottom, liters: en.l, bags: en.b, measured: true });
    });
    if (st.s) {
      if (el('mm-h') && st.s.h) el('mm-h').value = st.s.h;
      if (el('mm-top') && st.s.t) el('mm-top').value = st.s.t;
      if (el('mm-bottom') && st.s.b) el('mm-bottom').value = st.s.b;
    }
    if (st.p && byName[st.p]) picked = byName[st.p];
    if (st.v) setVolOnly(true);
    renderPicked();
    renderAll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var rootEl = el('mm-root');
    if (!rootEl || !CFG.dbUrl) return;
    fetch(CFG.dbUrl).then(function (r) { return r.json(); }).then(function (data) {
      db = data || [];
      init();
    }).catch(function () {
      rootEl.innerHTML = '<p class="mm-note">Could not load the plant database. Please refresh the page.</p>';
    });
  });

  function init() {
    /* autocomplete */
    var input = el('mm-search'), list = el('mm-list');
    if (!input || !list) return;
    var run = debounce(function () {
      var matches = searchPlants(input.value, db);
      if (!matches.length) { list.innerHTML = ''; list.hidden = true; return; }
      list.innerHTML = matches.map(function (p, i) {
        return '<button type="button" class="mm-opt" data-i="' + i + '">' +
               '<span>' + esc(p.commonName) + '</span>' +
               '<span class="mm-opt-mix">' + esc(shortMix(p.mix)) + '</span></button>';
      }).join('');
      list.hidden = false;
      list.querySelectorAll('.mm-opt').forEach(function (b) {
        b.addEventListener('click', function () {
          picked = matches[parseInt(b.dataset.i, 10)];
          input.value = ''; list.innerHTML = ''; list.hidden = true;
          renderPicked(); renderPreview(); saveState();
        });
      });
    }, 150);
    input.addEventListener('input', run);
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#mm-search') && !e.target.closest('#mm-list')) list.hidden = true;
    });

    ['mm-h', 'mm-top', 'mm-bottom'].forEach(function (id) {
      var i = el(id);
      if (i) i.addEventListener('input', updatePot);
    });

    var vo = el('mm-volonly');
    if (vo) vo.addEventListener('click', function () { setVolOnly(!volOnly); saveState(); });

    restoreState();   /* resume any in-progress session (e.g. after reading a mix page) */
    updatePot();      /* draw the pot + volume at the current slider positions */
  }

  function setVolOnly(on) {
    volOnly = on;
    var r = el('mm-root');
    if (r) r.classList.toggle('mm--volonly', on);
    var b = el('mm-volonly');
    if (b) b.innerHTML = on
      ? 'Back to plant matching'
      : 'Forget the plant &amp; mix &mdash; just calculate my pot&rsquo;s litres';
    renderPreview();
  }

  /* ---- Live pot graphic: labels, slider fill, SVG shape, volume text ---- */
  function sliderFill(input) {
    var min = parseFloat(input.min), max = parseFloat(input.max), v = parseFloat(input.value);
    var p = ((v - min) / (max - min)) * 100;
    input.style.background = 'linear-gradient(to right, #F2F4EE 0%, #F2F4EE ' + p + '%, rgba(242,244,238,0.18) ' + p + '%, rgba(242,244,238,0.18) 100%)';
  }

  function updatePot() {
    var hEl = el('mm-h'), tEl = el('mm-top'), bEl = el('mm-bottom');
    if (!hEl || !tEl || !bEl) return;
    var h = parseFloat(hEl.value), top = parseFloat(tEl.value), bottom = parseFloat(bEl.value);

    var hv = el('mm-h-val'), tv = el('mm-top-val'), bv = el('mm-bottom-val');
    if (hv) hv.textContent = h.toFixed(1);
    if (tv) tv.textContent = top.toFixed(1);
    if (bv) bv.textContent = bottom.toFixed(1);
    sliderFill(hEl); sliderFill(tEl); sliderFill(bEl);

    /* SVG pot: scale cm -> px so the biggest dimension fits the drawing */
    var s = 150 / Math.max(top, bottom, h, 24);
    var cx = 110, y0 = 36;
    var tw = top * s, bw = bottom * s, hh = h * s;
    var rim = el('mm-pot-rim'), body = el('mm-pot-body'), volTxt = el('mm-pot-vol');
    if (rim) rim.setAttribute('points',
      (cx - tw / 2 - 10) + ',' + (y0 - 14) + ' ' + (cx + tw / 2 + 10) + ',' + (y0 - 14) + ' ' +
      (cx + tw / 2 + 3) + ',' + y0 + ' ' + (cx - tw / 2 - 3) + ',' + y0);
    if (body) body.setAttribute('points',
      (cx - tw / 2) + ',' + y0 + ' ' + (cx + tw / 2) + ',' + y0 + ' ' +
      (cx + bw / 2) + ',' + (y0 + hh) + ' ' + (cx - bw / 2) + ',' + (y0 + hh));
    if (volTxt) {
      var vol = potVolumeLiters(h, top, bottom);
      var label = vol.toFixed(1) + 'L';
      volTxt.textContent = label;
      volTxt.setAttribute('x', cx);
      /* Inside the pot only when BOTH tall enough and wide enough for the
         actual string (~15px per character at this font size). Otherwise sit
         below the pot, clamped so it can never leave the SVG canvas. */
      var needW = label.length * 15;
      if (hh >= 64 && Math.min(tw, bw) >= needW) {
        volTxt.setAttribute('y', (y0 + hh / 2 + 11).toFixed(0));
      } else {
        volTxt.setAttribute('y', Math.min(y0 + hh + 36, 240).toFixed(0));
      }
    }
    renderPreview();
    saveState();   /* keep slider positions across navigation */
  }

  function renderPicked() {
    var lbl = el('mm-picked');
    if (!lbl) return;
    if (!picked) { lbl.innerHTML = ''; return; }
    lbl.innerHTML = 'Adding: <strong>' + esc(picked.commonName) + '</strong> ' +
      '<button type="button" class="mm-chip-x" id="mm-unpick" aria-label="Clear plant">&times;</button>';
    var c = el('mm-unpick');
    if (c) c.addEventListener('click', function () {
      picked = null; renderPicked(); renderPreview(); saveState();
    });
  }

  function dims() {
    var h = parseFloat((el('mm-h') || {}).value);
    var top = parseFloat((el('mm-top') || {}).value);
    var bottom = parseFloat((el('mm-bottom') || {}).value);
    return (h > 0 && top > 0 && bottom > 0) ? { h: h, top: top, bottom: bottom } : null;
  }

  function renderPreview() {
    var out = el('mm-preview');
    if (!out) return;
    var d = dims();
    if (!d) { out.innerHTML = ''; return; }

    /* "Forget the plant & mix" mode: litres (and bag equivalent) only */
    if (volOnly) {
      var v0 = potVolumeLiters(d.h, d.top, d.bottom);
      var b0 = bagsNeeded(v0);
      var vh = '<p class="mm2-line">Your pot holds approximately <strong>' + v0.toFixed(1) + ' litres</strong>.</p>' +
        '<p class="mm2-line">One 1 kg bag fills about <strong>' + esc(BAGVOL) + '</strong>, so filling it takes <strong>' +
        b0.bagsTrueNeed + ' bag' + (b0.bagsTrueNeed === 1 ? '' : 's') + '</strong>.</p>';
      if (b0.exceedsCap) {
        vh += '<p class="mm-note">That is more than our ' + CAP + '-bag order limit in one go &mdash; email ' +
          esc(MAIL) + ' and we will help you plan a bulk order.</p>';
      }
      out.innerHTML = vh;
      return;
    }

    if (!picked) {
      out.innerHTML = '<p class="mm-note">Pick a plant (step 1) to add this pot to your collection.</p>';
      return;
    }

    var vol = potVolumeLiters(d.h, d.top, d.bottom);
    var liters = vol * 0.85;   /* root-ball allowance */
    var b = bagsNeeded(liters);
    var bags = b.bagsToBuy, over = b.exceedsCap, trueNeed = b.bagsTrueNeed;

    var html = '<p class="mm2-line">This pot holds approximately <strong>' + vol.toFixed(1) + ' litres</strong> &mdash; about <strong>' +
      liters.toFixed(1) + ' litres</strong> of substrate after your ' + esc(picked.commonName) + '&rsquo;s root ball.</p>';
    html += '<p class="mm2-line">One 1 kg bag fills about <strong>' + esc(BAGVOL) + '</strong>. We total the litres per mix across your whole collection, so you only buy a bag when the pots actually need it.</p>';
    if (over) {
      html += '<p class="mm-note">This pot alone needs about ' + trueNeed + ' bags &mdash; more than our ' + CAP +
        '-bag order limit. We recommend placing separate orders, or emailing ' + esc(MAIL) + ' to plan a bulk order.</p>';
    }
    html += '<button type="button" class="mm-btn mm-btn--ghost" id="mm-addplant">Add ' + esc(picked.commonName) + ' to my collection</button>';
    out.innerHTML = html;

    var add = el('mm-addplant');
    if (add) add.addEventListener('click', function () {
      entries.push({
        plant: picked,
        h: d.h, top: d.top, bottom: d.bottom,
        liters: liters,
        bags: bags,
        measured: true
      });
      picked = null; renderPicked();
      out.innerHTML = '';
      showAllRows = false;
      renderAll();
      saveState();
      var s = el('mm-search');
      if (s) s.focus();
    });
  }

  function renderAll() {
    renderEntries();
    renderResult();
  }

  function renderEntries() {
    var wrap = el('mm-entries');
    if (!wrap) return;
    if (!entries.length) { wrap.innerHTML = ''; return; }
    var html = '<div class="mm2-plan-h">Your collection &middot; ' + entries.length + ' plant' + (entries.length === 1 ? '' : 's') + '</div>';
    entries.forEach(function (e, i) {
      html += '<div class="mm2-entry">' +
        '<span class="mm2-entry-plant">' + esc(e.plant.commonName) + '</span>' +
        '<span class="mm2-entry-dims">' + e.h + ' &times; ' + e.top + ' &times; ' + e.bottom + ' cm</span>' +
        '<span class="mm2-entry-mix">' + esc(shortMix(e.plant.mix)) + '</span>' +
        '<span class="mm2-entry-bags">' + e.liters.toFixed(1) + ' L</span>' +
        '<button type="button" class="mm-chip-x mm2-entry-x" data-i="' + i + '" aria-label="Remove ' + esc(e.plant.commonName) + '">&times;</button>' +
        '</div>';
    });
    wrap.innerHTML = html;
    wrap.querySelectorAll('.mm2-entry-x').forEach(function (b) {
      b.addEventListener('click', function () {
        entries.splice(parseInt(b.dataset.i, 10), 1);
        showAllRows = false;
        renderAll();
        saveState();
      });
    });
  }

  function renderResult() {
    var out = el('mm-out');
    if (!out) return;
    if (!entries.length) { out.innerHTML = ''; return; }

    var plants = entries.map(function (e) { return e.plant; });
    var result;
    if (plants.length === 1) {
      result = { mixSet: [plants[0].mix],
        assignments: [{ plant: plants[0], assignedMix: plants[0].mix, compatibility: plants[0].compatibility }],
        avgScore: plants[0].compatibility };
    } else {
      result = findBestMixSet(plants);
    }

    /* POOL LITRES PER MIX, then convert to bags. Two 1.6 L pots assigned to
       the same mix = 3.2 L = still 1 bag: a new bag is only added once a
       mix's pooled litres cross the next BAGMAX (bag stretch limit) threshold. */
    var mixLitres = {}, mixBags = {}, covered = {}, totalBags = 0;
    result.assignments.forEach(function (a, i) {
      mixLitres[a.assignedMix] = (mixLitres[a.assignedMix] || 0) + (entries[i] ? entries[i].liters : 0);
      (covered[a.assignedMix] = covered[a.assignedMix] || []).push(a.plant.commonName);
    });
    Object.keys(mixLitres).forEach(function (h) {
      mixBags[h] = Math.max(1, Math.ceil(mixLitres[h] / BAGMAX - 0.000001));
      totalBags += mixBags[h];
    });
    var usedMixes = Object.keys(covered);
    var avg = Math.round(result.avgScore);

    var html = '<div class="mm-summary">' +
      '<div class="mm-summary-h">You have ' + plants.length + ' plant' + (plants.length === 1 ? '' : 's') +
      '. We recommend ' + usedMixes.length + ' mix' + (usedMixes.length === 1 ? '' : 'es') + ' &mdash; ' + totalBags + ' bag' + (totalBags === 1 ? '' : 's') + ' in total.</div>' +
      '<p class="mm-summary-sub">The smallest set of mixes that keeps your whole collection thriving, at ' +
      avg + '% average compatibility. Bag counts come from your pot sizes.</p></div>';

    html += '<div class="mm-mixes">';
    usedMixes.forEach(function (h) {
      var names = covered[h];
      var shown = names.slice(0, 6).map(esc).join(', ');
      if (names.length > 6) shown += ' and ' + (names.length - 6) + ' more';
      var url = MIXES[h] && MIXES[h].url;
      html += '<div class="mm-mixcard">' +
        '<div class="mm-mixcard-top"><span class="mm-mixcard-name">' +
        (url ? '<a href="' + esc(url) + '" target="_blank" rel="noopener">' + esc(shortMix(h)) + '</a>' : esc(shortMix(h))) +
        '</span><span class="mm-mixcard-count">' + mixBags[h] + ' bag' + (mixBags[h] === 1 ? '' : 's') + ' &middot; ' + mixLitres[h].toFixed(1) + ' L &middot; covers ' + names.length + '</span></div>' +
        '<p class="mm-mixcard-plants">' + shown + '</p>' +
        '</div>';
    });
    html += '</div>';

    var rows = result.assignments;
    var limited = !showAllRows && rows.length > 20;
    var visible = limited ? rows.slice(0, 20) : rows;
    html += '<div class="mm-rows">';
    visible.forEach(function (a, i) {
      var pct = a.compatibility;
      var lit = entries[i] ? entries[i].liters : 0;
      html += '<div class="mm-row">' +
        '<span class="mm-row-plant">' + esc(a.plant.commonName) + '</span>' +
        '<span class="mm-row-mix">' + esc(shortMix(a.assignedMix)) + '</span>' +
        '<span class="mm-bar"><span class="mm-bar-fill" style="width:' + pct + '%"></span></span>' +
        '<span class="mm-row-pct">' + pct + '%</span>' +
        '<span class="mm2-entry-bags">' + lit.toFixed(1) + ' L</span>' +
        '</div>';
      if (pct < 70) {
        html += '<p class="mm-row-flag">' + esc(a.plant.commonName) + ' would do even better in ' +
          esc(shortMix(a.plant.mix)) + ' (' + a.plant.compatibility + '%) if purchased separately.</p>';
      }
    });
    if (limited) {
      html += '<button type="button" class="mm-showall" id="mm-showall">Show all ' + rows.length + ' plants</button>';
    }
    html += '</div>';

    /* totals + add */
    html += '<div class="mm-total">';
    var tier = tierFor(totalBags), single = singleBagPaise();
    if (tier && single) {
      var full = single * totalBags, save = full - tier.p;
      html += '<div class="mm-total-line"><strong>' + totalBags + ' bag' + (totalBags === 1 ? '' : 's') + ' &mdash; ' + rs(tier.p) + '</strong>' +
        (save > 0 ? ' instead of ' + rs(full) + '. <span class="mm-save">You save ' + rs(save) + '.</span>' : '') + '</div>';
    } else {
      html += '<div class="mm-total-line"><strong>' + totalBags + ' bag' + (totalBags === 1 ? '' : 's') + ' total</strong></div>';
    }
    if (totalBags > CAP) {
      html += '<p class="mm-note">Orders are capped at ' + CAP + ' bags per order. Remove a plant or contact us at ' +
        esc(MAIL) + ' for larger requirements.</p>';
    }
    html += '</div>';
    html += '<button type="button" class="mm-btn" id="mm-addall"' + (totalBags > CAP ? ' disabled' : '') + '>Add all to cart</button>';

    out.innerHTML = html;

    var sa = el('mm-showall');
    if (sa) sa.addEventListener('click', function () { showAllRows = true; renderResult(); });
    var add = el('mm-addall');
    if (add) add.addEventListener('click', function () {
      var counts = {};
      Object.keys(mixBags).forEach(function (h) { counts[mixTitle(h)] = mixBags[h]; });
      addBundle(counts, add);
    });
  }
})();
